import React, { useEffect, useState } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import TextField from "@mui/material/TextField";
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, styled } from '@mui/material';
import MaskedTextInput from './masked-textinput';
import useRwUtils from '../../../../hooks/use-rw-utils';
import { usePlacesWidget } from "react-google-autocomplete";
import IComponent from '../../../../services/forms.interface';
import AutoCompleteInput from './autocomplete';
import DateAndTimePickers from './date-picker';

interface ICustomProps {
    name: string;
    type: string;
    value: string;
    defaultValue: string;
    disabled: boolean;
    read_only: string;
    required: boolean;
    maskKey: string;
    error: any;
    onChange: any;
    onBlur: any;
    label: string;

}

interface IInsurance {
    Insurance_components: IInsuranceComponents[];
    formatted_Insurance: string;
}

interface IInsuranceComponents {
    long_name: string;
    short_name: string;
    types: string[];
}

interface IInsuranceState {
    company: IComponent,
    firstName?: IComponent,
    lastName?: IComponent,
    memberId?: IComponent,
    dateOfBirth?: IComponent,
}


const useStyles = makeStyles((theme) => ({
    insuranceContainer: {
        display: 'flex',
        flexDirection: 'row',
        flexBasis: '100%',
        flexWrap: 'wrap',
    },
    company: {
        flexBasis: '100%',
        marginBottom: '1em',
        marginTop: '.5em'
    },
    Insurance2: {
        flexBasis: '100%',
        marginBottom: '.5em'
    },
    firstName: {
        flexBasis: (props: any) => props.isMobile ? '100%' : '49%',
        marginBottom: '1em'
    },
    lastName: {
        flexBasis: (props: any) => props.isMobile ? '100%' : '49%',
        marginBottom: '1em'
    },
    memberId: {
        flexBasis: (props: any) => props.isMobile ? '100%' : '49%',
        marginBottom: '.5em'
    },
    dateOfBirth: {
        flexBasis: (props: any) => props.isMobile ? '100%' : '49%',
        marginBottom: '.5em'
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        flexBasis: '100%',
        flexWrap: 'nowrap',
        justifyContent: 'space-between',
    },
    stateInputLabel: {
        '&:not(.MuiInputLabel-shrink)': {
            margin: '-7px 0',
        }
    }
}));

const StyledTextField = styled(TextField)({
    '& .MuiOutlinedInput-root': {
        backgroundColor: '#F9F9F9',
    },
});

const Row = (props: any) => {
    return (
        <React.Fragment>
            {props.isMobile &&
                <div className={props.classes}>
                    {props.children}
                </div >
            }
            {!props.isMobile &&
                props.children
            }
        </React.Fragment>
    );
}

const Insurance: React.FC<IComponent> = props => {
    const classes = useStyles(props);

    const localProps: ICustomProps = {} as ICustomProps;
    localProps.type = 'text';
    localProps.required = (props.hasOwnProperty('required') && props.required === true && !props.read_only);

    if (props.error) { localProps.error = true; }

    if (props.disabled)
        localProps.disabled = true;

    const localInsurance2Props = { ...localProps };
    localInsurance2Props.required = false;

    let baseClasses = 'item SortableItem rfb-item';
    if (props.editMode) { baseClasses += ' is-editing'; }
    if (!props.editMode) { baseClasses += ' not-is-editing'; }
    if (props.selected) { baseClasses += ' selected'; }

    const handleAutocompleteChange = (event, id, value) => {
        props.handleChange(event, id, value, props.id);
    };

    const handleChange = (event) => {
        props.handleChange(event, event.target.id, event.target.value, props.id);
    };

    const handleDateChange = (value, id) => {
        props.handleChange(null, id, value, props.id);
    }

    const getComponent = (type) => {
        let found: any = {};

        if (!props.childComponents)
            return found;

        Object.values(props?.childComponents).forEach((comp: any, i) => {
            let fieldName = comp?.field_name || comp?.field_Name;
            fieldName = fieldName?.toLowerCase();
            if (fieldName.indexOf(type) !== -1)
                found = comp
        });
        
        if (found.error) { found.error = true; }
        if (!found.value) { found.value = ''; }
        if (props.required) { found.required = true; }
      
        return found;
    }

    const company = getComponent('insurance_dental_primary_policy_company_name');
    const firstName = getComponent('insurance_dental_primary_insured_party_name_first');
    const lastName = getComponent('insurance_dental_primary_insured_party_name_last');
    const memberId = getComponent('insurance_dental_primary_policy_id');
    const dateOfBirth = getComponent('insurance_dental_primary_insured_party_date_of_birth');

    if (!company || !company.options)
        return <></>;

    return (
        <div className={baseClasses}>

            <div className={classes.insuranceContainer}>


          
                    <>
                        <Row isMobile={!props.isMobile} classes={classes.row}>
                        <Row isMobile={props.isMobile} classes={classes.row}>
                            <div className={classes.company}>
                                <AutoCompleteInput id={company?.id} name={company.name} type={company.type} label={company.label} optionsSource={1} options={company.options} value={company.value} error={company.error} handleChange={handleAutocompleteChange} required={localProps.required} />
                            </div>
                        </Row>
                        </Row>
                        <Row isMobile={!props.isMobile} classes={classes.row}>
                            <Row isMobile={props.isMobile} classes={classes.row}>
                            <StyledTextField variant="outlined" error={firstName.error} required={localProps.required} onChange={handleChange}
                                id={firstName.id} label={firstName.label} name={firstName.name} value={firstName.value} className={classes.firstName} size="small" />
                            </Row>
                            <Row isMobile={props.isMobile} classes={classes.row}>
                            <StyledTextField variant="outlined" error={lastName.error} required={localProps.required} onChange={handleChange}
                                    id={lastName.id} label={lastName.label} name={lastName.name} value={lastName.value} className={classes.lastName} size="small" />
                            </Row>
                    </Row>
                    <Row isMobile={!props.isMobile} classes={classes.row}>
                        <Row isMobile={props.isMobile} classes={classes.row}>
                            <StyledTextField variant="outlined" error={memberId.error} required={localProps.required} onChange={handleChange}
                                id={memberId.id} label={memberId.label} name={firstName.name} value={memberId.value} className={classes.memberId} size="small" />
                        </Row>
                        <Row isMobile={props.isMobile} classes={classes.row}>
                            <div className={classes.dateOfBirth}>
                                <DateAndTimePickers error={dateOfBirth.error } required={localProps.required} handleChange={handleDateChange} type={dateOfBirth.type}
                                    id={dateOfBirth.id} label={dateOfBirth.label} name={dateOfBirth.name} value={dateOfBirth.value} />
                                </div>
                        </Row>
                    </Row>
                    </>

                
            </div>

        </div>

    );
}

export default Insurance;



